import React, { useEffect, useState } from 'react';
import { Table, Button, message, Select, DatePicker, Spin } from 'antd';
import { Timesheetapi } from '../../../middleware/interceptor';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Item from 'antd/es/list/Item';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";


const today = dayjs().utc().toDate();



dayjs.extend(utc);
dayjs.extend(timezone);

const { RangePicker } = DatePicker;

export const Approvals = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsData, setSelectedRowsData] = useState([]);
    const [loading, setloading] = useState(false);
    const [sDate, setSdate] = useState()
    const [eDate, setEdate] = useState()
    const [approvals, setApprovals] = useState([]);
    const [Temp, setTemp] = useState([]);

    const [selectedTimePeriod, setSelectedTimePeriod] = useState('week');


    const [filterdata, setfilterdata] = useState([]);

    const [clients, setclients] = useState([{ label: 'All', value: 1 }]);
    const [Projects, setprojects] = useState([{ label: 'All', value: 1 }]);
    const [employee, setemployee] = useState([{ label: 'All', value: 1 }]);



    const [selectedclients, setselectedclients] = useState(1);
    const [selectedProjects, setselectedprojects] = useState(1);
    const [selectedemployee, setselectedemployee] = useState(1);

    const [selectedDates, setSelectedDates] = useState([]);

    const [selectedWeekDates, setSelectedWeekDates] = useState([]);

    const options = [
        { label: 'Day Approve', value: 'day' },
        { label: 'Weekly Approve', value: 'week' },
        { label: 'Monthly Approve', value: 'month' }
    ];

    const columns = [
        {
            title: 'Date',
            dataIndex: 'commentDate',
            key: 'commentDate',
            align: 'center', // header center
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div> // row data left
        },
        {
            title: 'Clients',
            dataIndex: 'clientName',
            key: 'clientName',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Projects',
            dataIndex: 'projectName',
            key: 'projectName',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Employees',
            dataIndex: 'employeeName',
            key: 'employeeName',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Tasks',
            dataIndex: 'taskName',
            key: 'taskName',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Comments',
            dataIndex: 'commentContent',
            key: 'commentContent',
            align: 'center',
            render: (text) => <div style={{ textAlign: 'left' }}>{text}</div>
        },
        {
            title: 'Hrs',
            dataIndex: 'commentHours',
            key: 'commentHours',
            align: 'center', // header center
            render: (text) => <div style={{ textAlign: 'right' }}>{text}</div> // row data right
        }
    ];



    const formatDateToDDMMYYYY = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`; // Format as yyyy-mm-dd
    };


    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys, newSelectedRows) => {
            setSelectedRowKeys(newSelectedRowKeys);
            setSelectedRowsData(newSelectedRows);
        },

    };
    console.log(selectedRowsData, 'selectedRowsData')

    const approve = async () => {
        if (selectedRowKeys.length === 0) {
            message.warning('Please select at least one employee to approve.');
            return;
        }

        setloading(true);

        let filter = selectedRowsData.map(Item => Item.commentId)

        console.log(filter, "filter")
        await Timesheetapi.post(`api/Projects/Approval`, filter).then((Responce) => {

            if (Responce.data == "sucess") {
                message.success(`Approve Sucess`);
                getapprovalsdata();

            }
        })
    };

    const deny = async () => {
        if (selectedRowKeys.length === 0) {
            message.warning('Please select at least one employee to deny.');
            return;
        }

        setloading(true);
        let empid=localStorage.getItem("employee_id");
        let filter = selectedRowsData.map(Item => Item.commentId)

        let payload={
           empid:empid,
           Ids: filter,
        }

        console.log(filter, "filter")
        await Timesheetapi.post(`api/Projects/Deny`, payload).then((Responce) => {

            if (Responce.data == "sucess") {
                getapprovalsdata();
                message.error(`Approve Denied `);

            }

        })
    };


    useEffect(() => {
        const initialRender = async () => {
            if (selectedTimePeriod === 'month' || selectedTimePeriod === 'year' || selectedTimePeriod === 'day') {
                const currentStartDate = dayjs().utc().startOf(selectedTimePeriod);
                const currentEndDate = dayjs().utc().endOf(selectedTimePeriod);

                setSdate(currentStartDate.format("YYYY-MM-DD"));
                setEdate(currentEndDate.format("YYYY-MM-DD"));
            }
        };
        initialRender();
    }, [selectedTimePeriod]);


    useEffect(() => {
        if (sDate && eDate) {
            getapprovalsdata();

        }
    }, [sDate, eDate])

    useEffect(() => {
        if (selectedTimePeriod === 'week') {
            const weekDates = async () => {
                await handleWeekSelection([today]);
                console.log("ENTERED WEEK", handleWeekSelection([today]))
            }
            weekDates()
        }
    }, [selectedTimePeriod]);






    const getapprovalsdata = async () => {

        setloading(true);

        let Url = localStorage.getItem('emp_role_id') == 3 ? 'api/Projects/TeamLeadWorkingHours' : "api/Projects/TeamWorkingHours";

        await Timesheetapi.post(`${Url}?empid=${localStorage.getItem('employee_id')}&&sdate=${sDate}&&edate=${eDate}`).then(async (response) => {

            const flattenedData = await flattenApprovalsData(response.data.Results);

            setloading(false);

            let filteredData = response.data.Results.map(client => {
                const filteredProjects = client.Project_List.map(project => {
                    const filteredWorkitems = project.workitems.filter(item => item.comments && item.comments.length > 0);
                    return {
                        ...project,
                        workitems: filteredWorkitems
                    };
                }).filter(project => project.workitems.length > 0);

                return {
                    ...client,
                    Project_List: filteredProjects
                };
            }).filter(client => client.Project_List.length > 0);

            // Step 2: Create select options




            let clientOptions = response.data.Results.map(client => ({
                label: client.Client_name,
                value: client.Client_id
            }));

            setfilterdata(filteredData)
            console.log("filteredData", filteredData);

            setApprovals(flattenedData);
            setTemp(flattenedData);
            setclients([{ label: 'All', value: 1 }, ...clientOptions]);

            setselectedclients(selectedclients)


            setprojects([{ label: 'All', value: 1 }])
            setemployee([{ label: 'All', value: 1 }])
            setselectedprojects(1)
            setselectedemployee(1)

        }).catch((err) => {

        })


    }



    const handleChange = (value) => {

        setSelectedTimePeriod('month')

        setselectedclients(value);

        // let filter = filterdata.filter(client => client.Client_id === value);

        // console.log(filter, "filter");

        // if (filter.length > 0) {

        //     let project = filter[0].Project_List.map(project => ({
        //         label: project.Project_name,
        //         value: project.Project_id
        //     }))

        //     console.log(project, "filter");
        //     setprojects([{ label: 'All', value: 1 }, ...project]);

        // } else {
        //     setprojects([{ label: 'All', value: 1 }])
        //     setselectedprojects(1)
        // }


        // setemployee([{ label: 'All', value: 1 }]);
        // setselectedemployee(1)
        // 
    };

    const handleChangeproject = (value) => {
        let employeeMap = new Map();

        setselectedprojects(value);

        // setemployee([{ label: 'All', value: 1 }]);
        setselectedemployee(1)
        filterdata.forEach(client => {
            client.Project_List.forEach(project => {
                if (project.Project_id === value) {
                    project.workitems
                        .filter(item => item.comments && item.comments.length > 0)
                        .forEach(item => {
                            if (!employeeMap.has(item.employee_id)) {
                                employeeMap.set(item.employee_id, {
                                    label: item.employee_name,
                                    value: item.employee_id
                                });
                            }
                        });
                }
            });
        });

        const employeeList = Array.from(employeeMap.values());

        setemployee([{ label: 'All', value: 1 }, ...employeeList]);
        console.log(employeeList, "employeeList");
    };







    const flattenApprovalsData = async (data) => {
        const result = [];

        data.forEach(client => {
            const clientName = client.Client_name;

            client.Project_List.forEach(project => {
                const projectName = project.Project_name;

                project.workitems.forEach(workitem => {
                    const employeeName = workitem.employee_name;
                    const taskName = workitem.ItemName;

                    // Only include if comments exist
                    if (workitem.comments && workitem.comments.length > 0) {
                        workitem.comments.forEach(comment => {
                            result.push({
                                clientName,
                                key: comment.CommentId,
                                projectName,
                                employeeName,
                                taskName,
                                Client_id: client.Client_id,
                                Project_id: project.Project_id,
                                Employee_id: workitem.employee_id,
                                commentId: comment.CommentId,
                                commentContent: comment.content,
                                commentDate: comment.comments_Date,
                                commentHours: comment.Comment_hrs
                            });
                        });
                    }
                });
            });
        });

        return result;
    };




    const handleDateChange = (date, dateString) => {



        if (date && date.length === 2) {

            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


            const startMonth = date[0];
            const endMonth = date[1];

            if (selectedTimePeriod === 'month' || selectedTimePeriod === 'year' || selectedTimePeriod === 'day') {
                const startOfMonth = dayjs(startMonth).tz(userTimeZone).startOf(selectedTimePeriod).format("YYYY-MM-DD");
                const endOfMonth = dayjs(endMonth).tz(userTimeZone).endOf(selectedTimePeriod).format("YYYY-MM-DD");

                console.log(startOfMonth, endOfMonth, 'endOfMonth')
                setSdate(startOfMonth);
                setEdate(endOfMonth);
                return;
            }
        }
    };





    const handleTimePeriodChange = (value) => {
        setSelectedTimePeriod(value)
        const currentStartDate = dayjs().startOf(value);
        const currentEndDate = dayjs().endOf(value);
        setSelectedDates([
            currentStartDate,
            currentEndDate,
        ])
    }


    const handleWeekSelection = (selectedDates_, instance) => {
        if (instance) { instance.close(); }

        if (selectedDates_.length > 0) {
            const selectedTempDate = selectedDates_[0];

            // Normalize to start of day to avoid timezone drift
            selectedTempDate.setHours(0, 0, 0, 0);

            const startOfWeek = new Date(selectedTempDate);
            const dayOfWeek = startOfWeek.getDay();
            const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

            startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
            startOfWeek.setHours(0, 0, 0, 0); // Normalize again just in case

            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);
            endOfWeek.setHours(0, 0, 0, 0); // Normalize

            setSelectedWeekDates([startOfWeek, endOfWeek]);
            setSdate(formatDateToDDMMYYYY(new Date(startOfWeek)));
            setEdate(formatDateToDDMMYYYY(new Date(endOfWeek)));

            console.log("ytrew", [
                formatDateToDDMMYYYY(new Date(startOfWeek)),
                formatDateToDDMMYYYY(new Date(endOfWeek))
            ]);

            const newDateList = Array.from({ length: 7 }, (_, index) => {
                const date = new Date(startOfWeek);
                date.setDate(startOfWeek.getDate() + index);
                date.setHours(0, 0, 0, 0); // Normalize

                const formattedDate = date.toLocaleDateString("en-US", {
                    timeZone: "UTC", // Add this for consistency
                    weekday: "short",
                    month: "short",
                    day: "numeric",
                });

                console.log(formattedDate, 'selectedDates_');

                return {
                    accessorKey: formattedDate,
                    header: formattedDate,
                };
            });

            // setDateList(newDateList);
        }
    };



    useEffect(() => {

        const filtered = Temp.filter(project => {
            const clientMatch = selectedclients == 1 || project.Client_id === selectedclients;
            const projectMatch = selectedProjects == 1 || project.Project_id === selectedProjects;
            const employeeMatch = selectedemployee == 1 || project.Employee_id === selectedemployee;

            return clientMatch && projectMatch && employeeMatch;
        });

        setApprovals(filtered);

        console.log("Temp", selectedclients, selectedProjects, Temp, selectedemployee);
    }, [Temp, selectedclients, selectedProjects, selectedemployee]);


    useEffect(() => {

        let filter = filterdata.filter(client => client.Client_id === selectedclients);

        console.log(filter, "filter");

        if (filter.length > 0) {

            let project = filter[0].Project_List.map(project => ({
                label: project.Project_name,
                value: project.Project_id
            }))

            console.log(project, "filter");
            setprojects([{ label: 'All', value: 1 }, ...project]);
            setselectedprojects(1)


        } else {
            setprojects([{ label: 'All', value: 1 }])
            setselectedprojects(1)
        }


        setemployee([{ label: 'All', value: 1 }]);
        setselectedemployee(1)
    }, [Temp, selectedclients]);



    return (
        <div>
            <h2 className='page-heading relative top-[8px]'>Approvals</h2>
            <div className='flex items-center gap-[15px] mt-[-55px]'>

                <div className="flex flex-col gap-[5px] relative top-[82px] left-[10px]">
                    <label className="text-[13px] pl-2">Client:</label>

                    <Select
                        style={{ width: 150 }}
                        options={clients}
                        defaultValue={1}
                        value={selectedclients}
                        onChange={handleChange}
                    />
                </div>
                <div className="flex flex-col gap-[5px] relative top-[82px] left-[10px]">
                    <label className="text-[13px] pl-2">Project:</label>
                    <Select
                        style={{ width: 250 }}
                        // defaultValue={1}
                        value={selectedProjects}
                        onChange={handleChangeproject}
                        options={Projects}
                    />
                </div>
                <div className="flex flex-col gap-[5px] relative top-[82px] left-[10px]">
                    <label className="text-[13px] pl-2">Employee:</label>
                    <Select
                        style={{ width: 200 }}
                        defaultValue={1}
                        value={selectedemployee}
                        onChange={(e) => setselectedemployee(e)}
                        options={employee}
                    />
                </div>

                <div className="flex flex-col gap-[5px] relative top-[82px] left-[10px]">
                    <label className="text-[13px] pl-2">Time Periods:</label>

                    <Select
                        style={{ width: 170 }}
                        placeholder="Time Period"
                        value={selectedTimePeriod}
                        options={options}
                        onChange={handleTimePeriodChange}
                    />
                </div>
                <div className="flex flex-col gap-[5px] relative top-[82px] left-[10px]">
                    <label className="text-[13px] pl-2">Dates:</label>

                    {selectedTimePeriod === 'day' && (
                        <RangePicker
                            className="w-[235px] "
                            allowClear
                            defaultValue={[dayjs().startOf('day'), dayjs().endOf('day')]} // should be [dayjs(), dayjs()] or null
                            placeholder={['Start Date', 'End Date']}
                            format="DD-MM-YYYY"
                            onChange={handleDateChange}

                        />
                    )}
                    {selectedTimePeriod === 'month' && (
                        <RangePicker
                            className="w-[235px]"
                            allowClear={false}
                            defaultValue={[dayjs().startOf('month'), dayjs().endOf('month')]}
                            picker="month"
                            placeholder={['Start Month', 'End Month']}
                            format="MMMM YYYY"
                            onChange={handleDateChange}
                            disabled={loading}
                            disabledDate={(current) => {
                                // Disable future months
                                return current && current > dayjs().endOf('month');
                            }}
                        />
                    )}
                    {selectedTimePeriod === 'week' && (
                        <Flatpickr
                            className={`ant-select ant-select-outlined w-[235px] date-picker-client-report ${loading ? 'date-picker-client-report-disabled' : 'date-picker-client-report'}`}
                            value={selectedWeekDates}
                            options={{
                                mode: "range",
                                dateFormat: "D, M j",
                                onChange: (selectedDates, DaysDate, instance) => { handleWeekSelection(selectedDates, instance); },
                                disable: [
                                    function (date) {
                                        const week_selectedDate = today;
                                        const week_startOfWeek = new Date(week_selectedDate);
                                        const week_dayOfWeek = week_startOfWeek.getDay();
                                        const daysToMonday = week_dayOfWeek == 0 ? 6 : week_dayOfWeek - 1;
                                        week_startOfWeek.setDate(week_startOfWeek.getDate() - daysToMonday);
                                        const week_endOfWeek = new Date(week_startOfWeek);
                                        week_endOfWeek.setDate(week_startOfWeek.getDate() + 6);

                                        console.log(week_dayOfWeek, date, "week_endOfWeek")
                                        return date > week_endOfWeek;
                                    }
                                ],
                                // 
                            }}
                            noCalendar={loading}
                            placeholder="Select Week"
                        />
                    )}

                </div>

            </div>

            {
                loading ? (<>

                    <Spin size="small" tip="Loading..." className="justify-center items-center flex" style={{ height: '100vh' }}>
                        <div className='mt-3 approval-table pt-[70px]'>
                            <Table
                                rowSelection={rowSelection}
                                dataSource={approvals}
                                columns={columns}
                                pagination={false}
                            />
                            <div className='flex items-center justify-end mt-2 gap-2 px-[10px] pb-[10px]'>
                                <Button type="primary" onClick={approve}>
                                    Approve
                                </Button>
                                <Button danger onClick={deny}>
                                    Deny
                                </Button>
                            </div>
                        </div>
                    </Spin>
                </>) : (<>
                    <div className='mt-3 approval-table pt-[70px]'>

                        <Table
                            rowSelection={rowSelection}
                            dataSource={approvals}
                            columns={columns}
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: false // this hides the page size dropdown
                            }}
                        />


                        <div className='flex items-center justify-end mt-2 gap-2 px-[10px] pb-[10px]'>
                            <Button type="primary" onClick={approve}>
                                Approve
                            </Button>
                            <Button danger onClick={deny}>
                                Deny
                            </Button>
                        </div>
                    </div>
                </>
                )
            }

        </div>
    );
}
